import React, { useEffect, useState, useCallback } from 'react'
import { find, isEmpty } from 'lodash'
import FILTERED_TYPE from '../constant'
import LoadingModal from '../../LoadingModal'
import Button from '../../Button'
import ActiveFilters from '../../ActiveFilters'
import {
  getDefaultFilter,
  getUserFilteredColumnsStorageByUser,
  removeFromStoreByName,
  saveSelectedFilter
} from '../storeUtils'
import { showActiveFiltersPivot } from '../helpers/helpersPivot'
import { showActiveFilters } from '../helpers/helpersTable'
import { Dropdown } from '../../Dropdown'

const TableGetInfoFilterModal = ({ open, close, data }) => {
  const {
    tableApi,
    userId,
    // identifier,
    t,
    type,
    linksByUri,
    userPreferences,
    kind,
    updateUserDataPreferences,
    id,
    setIsActiveTabular
  } = data
  const defaultValue = {
    id: 'none',
    model: {},
    tabular: false,
    filter: {},
    selected: true
  }

  const [selectedRadio, setSelectedRadio] = useState(
    getDefaultFilter(
      { id, userId, /*  identifier, */ type, kind },
      userPreferences()
    ).name || defaultValue.id
  )
  const [radioList, setRadioList] = useState([defaultValue.id])
  const [columnsInfo, setColumnsInfo] = useState({}) // filterModel for TABLE or config columns model for PIVOT
  const [isTabular, setIsTabular] = useState(false)
  const [pivotFilterInfo, setPivotFilterInfo] = useState(null)
  const [columnsSaved, setColumnsSaved] = useState([])
  const [ubliqueLinks, setUbliqueLinks] = useState([])

  useEffect(() => {
    if (open) {
      if (type === FILTERED_TYPE.TABLE) {
        if (typeof linksByUri === 'function') {
          setUbliqueLinks(linksByUri())
        }
      }
    }
  }, [open])

  useEffect(() => {
    const saved = getUserFilteredColumnsStorageByUser(
      {
        id,
        userId,
        type,
        kind
      },
      userPreferences()
    )

    setColumnsSaved(saved)

    if (!isEmpty(saved)) {
      const list = saved.map((field) => field.name)
      setRadioList([defaultValue.id, ...list])
      setColumnsInfo(
        getTypeInfoFromId(selectedRadio ?? defaultValue.id, 'model')
      )
      setPivotFilterInfo(
        getTypeInfoFromId(selectedRadio ?? defaultValue.id, 'filter')
      )
      setIsTabular(
        getTypeInfoFromId(selectedRadio ?? defaultValue.id, 'tabular')
      )
    }

    // }
  }, [])

  useEffect(() => {
    setIsActiveTabular(isTabular)
  }, [isTabular])

  const onSaveModal = () => {
    if (type === FILTERED_TYPE.PIVOT) {
      tableApi.gridCore.columnApi.resetColumnState()

      if (isTabular) {
        tableApi.gridCore.gridOptions.groupDefaultExpanded = 5
        tableApi.gridCore.gridOptions.groupHideOpenParents = true
      } else {
        tableApi.gridCore.gridOptions.groupDefaultExpanded = 0
        tableApi.gridCore.gridOptions.groupHideOpenParents = false
      }

      isEmpty(columnsInfo)
        ? tableApi.gridCore.columnApi.resetColumnState()
        : tableApi.gridCore.columnApi.setColumnState(columnsInfo)

      if (!isEmpty(pivotFilterInfo)) {
        tableApi.gridCore.filterManager.setFilterModel(pivotFilterInfo)
        tableApi.gridCore.filterManager.onFilterChanged()
      } else {
        tableApi.gridCore.filterManager.setFilterModel(null)
        tableApi.gridCore.filterManager.onFilterChanged()
      }
    } else {
      tableApi.gridCore.filterManager.setFilterModel(columnsInfo)
      tableApi.gridCore.filterManager.onFilterChanged()
    }

    saveSelectedFilter(
      {
        selectedFilter: selectedRadio,
        userId,
        // identifier,
        type,
        kind,
        id,
        updateUserDataPreferences
      },
      userPreferences()
    )

    close()
  }

  const getTypeInfoFromId = (id, key /* key= model, tabular, filter */) => {
    if (id === defaultValue.id) return defaultValue?.[key]
    const filterList = columnsSaved /* [identifier] */ || []
    const obj = find(filterList, { name: id })

    return obj?.[key] ?? defaultValue?.[key]
  }

  useEffect(() => {
    setColumnsInfo(getTypeInfoFromId(selectedRadio, 'model'))
    setPivotFilterInfo(
      getTypeInfoFromId(selectedRadio ?? defaultValue.id, 'filter')
    )
    setIsTabular(getTypeInfoFromId(selectedRadio ?? defaultValue.id, 'tabular'))
  }, [selectedRadio, columnsSaved])

  const onChangeDropdown = (selItem) => {
    setSelectedRadio(selItem)
  }

  const removeSelectedFilter = () => {
    if (selectedRadio === defaultValue.id) return
    if (
      removeFromStoreByName(
        {
          filterName: selectedRadio,
          type,
          // identifier,
          userId,
          kind,
          updateUserDataPreferences,
          id
        },
        userPreferences()
      )
    ) {
      const columnsSaved = getUserFilteredColumnsStorageByUser(
        {
          id,
          userId,
          type,
          kind
        },
        userPreferences()
      )
      const filterList = columnsSaved /* [identifier] */ || []
      const list = filterList.map((field) => field.name)
      setRadioList([defaultValue.id, ...list])
      setColumnsInfo({})
      setSelectedRadio(defaultValue.id)
    }
  }
  const customHeaderModal = useCallback(() => {
    return (
      <div className='modal-header bx--modal-header__heading'>
        <h4>{t('FilterMenu.ColumnsChooseFilterModal.TITLE')}</h4>
      </div>
    )
  }, [t])

  const footerCustom = () => {
    return (
      <>
        <Button kind='secondary' size='default' onClick={close}>
          {t('Translations:Cancel')}
        </Button>

        <Button kind='danger' size='default' onClick={removeSelectedFilter}>
          {t('Translations:Delete')}
        </Button>
        <Button kind='primary' size='default' onClick={onSaveModal}>
          {t('Translations:Apply')}
        </Button>
      </>
    )
  }

  const renderBody = () => {
    if (type === FILTERED_TYPE.PIVOT) {
      return (
        <div>
          <ActiveFilters
            filters={showActiveFiltersPivot(columnsInfo, tableApi, t)}
            labels={{ subtitle: t('columns') }}
          />
          <ActiveFilters
            filters={showActiveFilters(pivotFilterInfo, tableApi)}
            labels={{ subtitle: t('filters') }}
          />
          <ActiveFilters
            filters={
              isEmpty(columnsInfo) && isEmpty(pivotFilterInfo)
                ? {}
                : {
                    [t('TableActions.Tabular.TABULAR')]: isTabular
                      ? [t('TableActions.Tabular.ACTIVE')]
                      : [t('TableActions.Tabular.NOT_ACTIVE')]
                  }
            }
            labels={{ subtitle: t('TableActions.Tabular.TABLE') }}
          />
        </div>
      )
    }
    return (
      <ActiveFilters
        filters={showActiveFilters(columnsInfo, tableApi, ubliqueLinks)}
        labels={{ subtitle: t('columns') }}
      />
    )
  }

  return (
    <LoadingModal
      size='md'
      open={open}
      onRequestClose={close}
      footerCustom={footerCustom()}
      modalHeading={customHeaderModal()}
      className='columnsFilter-modal-inputview'
      preventCloseOnClickOutside
    >
      <Dropdown
        itemToString={(id) => t(id)}
        items={radioList.map((id) => id)}
        selectedItem={selectedRadio}
        label=''
        onChange={({ selectedItem }) => onChangeDropdown(selectedItem)}
      />
      {renderBody()}
    </LoadingModal>
  )
}

export default TableGetInfoFilterModal
